import AbnormalityIncidentEditorPopup from './AbnormalityIncidentEditorPopup';

export default AbnormalityIncidentEditorPopup;
